var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOffer3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
    fill: "#E8F4FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 24C33.552 24 34.005 23.551 33.95 23.002C33.7195 20.7062 32.7021 18.5607 31.0703 16.9294C29.4386 15.298 27.2929 14.2811 24.997 14.051C24.447 13.996 23.999 14.449 23.999 15.001V23.001C23.999 23.2663 24.1044 23.5206 24.2919 23.7081C24.4794 23.8957 24.7338 24.001 24.999 24.001L33 24Z",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.21 27.89C32.5738 29.3944 31.5788 30.7202 30.3119 31.7513C29.045 32.7823 27.5448 33.4874 25.9424 33.8047C24.3401 34.1221 22.6844 34.0421 21.1202 33.5718C19.5559 33.1014 18.1306 32.255 16.969 31.1066C15.8074 29.9582 14.9448 28.5427 14.4566 26.9839C13.9685 25.4251 13.8696 23.7704 14.1686 22.1646C14.4676 20.5587 15.1555 19.0506 16.1721 17.772C17.1886 16.4934 18.5029 15.4833 20 14.83",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer3);
export default __webpack_public_path__ + "static/media/offer3.990622717cbf5b031749a3bbea68a407.svg";
export { ForwardRef as ReactComponent };